export default __webpack_public_path__ + "static/asb-starship-lockup-216063316b0e851ce1958bcf8095e9e8.png";